import React from 'react';
import SearchTabs from '../SearchTabs/SearchTabs';
import styles from './searchHeader.module.scss';
import classnames from 'classnames';
import { useLocation } from 'react-router';

interface SearchHeaderProps {
  pageTitle: string;
}

const SearchHeader = ({ pageTitle }: SearchHeaderProps) => {
  const location = useLocation();

  return (
    <div
      className={classnames(
        'd-flex justify-content-between position-relative z-index-1',
        styles.headerContainer,
        {
          [styles.isSearcher]: location.pathname.includes(
            '/requests/requester/'
          ),
        }
      )}
    >
      <div className="container-xl d-flex justify-content-between position-relative fix-bg-images">
        <div className="d-flex align-items-center text-truncate">
          <h1 className="m-0 text-truncate pr-1" role="heading">
            {pageTitle}
          </h1>
        </div>
        <div className={'d-flex align-items-center'}>
          <SearchTabs />
        </div>
      </div>
    </div>
  );
};

export default SearchHeader;
